import store from '../../store'
export default {
    actions: {
        async fetchRequest(ctx, data) {
            const options = {
                method: 'post',
                headers: store.state.headers,
                body: JSON.stringify(data)
            }
            const res = await fetch('https://api.expansium.ru/admin/api/v1/getRequestsClients', options);
            const requests = await res.json();
            ctx.commit('updateRequests', requests);
        },
        async getRequest(ctx, data){
            const options = {
                method: 'post',
                headers: store.state.headers,
                body: JSON.stringify(data)
            }
            const res = await fetch('https://api.expansium.ru/admin/api/v1/getRequestClient', options);
            const request = await res.json();
            ctx.commit('updateRequest', request);
        }
    },
    mutations: {
        updateRequests(state, requests){
            state.requests = requests.requests;
            state.cRequests = requests.cRequests;
        },
        updateRequest(state, request){
            state.request = request;
        },
    },
    state: {
        requests: [],
        request: [],
        cRequests: 0,
    },
    getters: {
        allRequests(state){
            return state.requests;
        },
        countRequests(state){
            return state.cRequests;
        },
        allBranchRequest(state){
            return state.request;
        }
    },
}